import ScreenWrapper from "@/components/ScreenWrapper"
import OrganizationDetailSidebar from "@/pages/organisaties/OrganizationDetailSidebar"
import { checkOrganizationPermissions } from "@/utils/checkOrganizationPermissions"
import { createFileRoute, Outlet } from "@tanstack/react-router"
import {
  DetailGoBackButton,
  LayoutWithSidebar,
  SidebarWrapper,
} from "toptaal-shared"

export const Route = createFileRoute("/organisatie-profiel")({
  component: RouteComponent,
  beforeLoad: () => checkOrganizationPermissions("read", "organization"),
})

function RouteComponent() {
  return (
    <ScreenWrapper className="!px-0">
      <LayoutWithSidebar
        disableRightPanelSuspense
        sidebar={
          <SidebarWrapper>
            <DetailGoBackButton label="Organisaties" />

            <OrganizationDetailSidebar />
          </SidebarWrapper>
        }
      >
        <Outlet />
      </LayoutWithSidebar>
    </ScreenWrapper>
  )
}
